export const OPEN_WEBSOCKET = "OPEN_WEBSOCKET";
export const OPEN_WEBSOCKET_LOGIN = "OPEN_WEBSOCKET_LOGIN";
export const SEND_MESSAGE = "SEND_MESSAGE";
export const CLOSE_WEBSOCKET = "CLOSE_WEBSOCKET";
export const ADD_PORTLET = "ADD_PORTLET";
export const SET_MENU = "SET_MENU";
export const SET_SETTINGS = "SET_SETTINGS";
export const SET_MESSAGES = "SET_MESSAGES";
export const SET_DOCUMENT_TYPES = "SET_DOCUMENT_TYPES";
export const SET_DOCUMENT_CATEGORIES = "SET_DOCUMENT_CATEGORIES";
export const SET_USER = "SET_USER";
export const SET_LAYOUTS = "SET_LAYOUTS";
export const ADD_LAYOUT = "ADD_LAYOUT";
export const REMOVE_LAYOUT = "REMOVE_LAYOUT";
export const CHANGE_SELECTED = "CHANGE_SELECTED";
export const SET_TEAM_LAYOUT_EDIT_MODE = "SET_TEAM_LAYOUT_EDIT_MODE";
export const UPDATE_LAYOUTS = "UPDATE_LAYOUTS";
export const RENAME_TAB = "RENAME_TAB";
export const SET_FILTERS = "SET_FILTERS";
export const SET_SEARCH = "SET_SEARCH";
export const SET_API_LOCATION = "SET_API_LOCATION";
export const DELETE_PORTLET = "DELETE_PORTLET";
export const DELETE_PORTLET_FROM_LAYOUT = "DELETE_PORTLET_FROM_LAYOUT";
export const ADD_PORTLET_TO_LAYOUT = "ADD_PORTLET_TO_LAYOUT";
export const ADD_MESSAGE = "ADD_MESSAGE";
export const UPDATE_MESSAGE = "UPDATE_MESSAGE";
export const SET_SELECTION_OPTIONS = "SET_SELECTION_OPTIONS";
export const CHANGE_SETTING = "CHANGE_SETTING";
export const EDIT_THEME = "EDIT_THEME";
export const SET_CUSTOM_FIELDS = "SET_CUSTOM_FIELDS";
export const DELETE_CUSTOM_FIELDS = "DELETE_CUSTOM_FIELDS";
export const ADD_CUSTOM_FIELDS = "ADD_CUSTOM_FIELDS";
export const SET_TEMPID = "SET_TEMPID";
export const SET_LAYOUT_TYPE = "SET_LAYOUT_TYPE";
export const CHANGE_LANGUAGE = "CHANGE_LANGUAGE";
export const SET_TAXONOMY_TREE = "SET_TAXONOMY_TREE";
export const SET_TAXONOMY_SUGGESTIONS = "SET_TAXONOMY_SUGGESTIONS";
export const SET_TAXONOMY_NODELOOKUP = "SET_TAXONOMY_NODELOOKUP";
export const SET_TABS = "SET_TABS";
export const SET_NOTIFICATIONS = "SET_NOTIFICATIONS";
export const SET_APPLICATION_PROPERTIES = "SET_APPLICATION_PROPERTIES";
export const ADD_OPEN = "ADD_OPEN";
export const REMOVE_OPEN = "REMOVE_OPEN";
export const ADD_CONTENT = "ADD_CONTENT";
export const EDITOR_FOCUSED = "EDITOR_FOCUSED";
export const SET_LICENCE = "SET_LICENCE";
export const SET_WHATS_USING = "SET_WHATS_USING";
export const SET_ISMOBILE = "SET_ISMOBILE";
export const SET_GLOBAL_ALERT = "SET_GLOBAL_ALERT";
export const SET_RUNNING_JOBS = "SET_RUNNING_JOBS";

